import { useMemo } from "react";

import { FlightWayEnum, RoundTripTypeEnum } from "@/constants";

import useSearchQuery from "./useSearchQuery";

const useTrackPriceDateRange = (roundTripType: RoundTripTypeEnum): number[] => {
  const { query } = useSearchQuery();

  return useMemo(() => {
    if (query.flightWay === FlightWayEnum.OneWay) {
      return query.range
        ? [query.oneWayRangeStartDate, query.oneWayRangeEndDate]
        : [query.oneWayDate, query.oneWayDate];
    } else {
      if (query.range) {
        if (roundTripType === RoundTripTypeEnum.Outbound) {
          return [query.departureRangeStartDate, query.departureRangeEndDate];
        }
        return [query.returnRangeStartDate, query.returnRangeEndDate];
      } else {
        if (roundTripType === RoundTripTypeEnum.Outbound) {
          return [query.roundTripDepartureDate, query.roundTripDepartureDate];
        }
        return [query.roundTripReturnDate, query.roundTripReturnDate];
      }
    }
  }, [query, roundTripType]);
};

export default useTrackPriceDateRange;
